import React, { useContext, useMemo } from "react";
import { format } from "date-fns";

import { Context } from "../../../store/student";
import styles from "../CareerAnswerHistory.module.scss";

const TABLE_TITLES = ["回数", "問い", "回答"];

const CareerQuestionTable = () => {
  const { contextState } = useContext(Context);
  const careerFeedbackQuestionsHistories =
    contextState.career_feedback_questions_histories;
  const sortedHistoriesByTermNo = useMemo(() => {
    return [...careerFeedbackQuestionsHistories].sort(
      (a, b) => b.term_no - a.term_no,
    );
  }, [careerFeedbackQuestionsHistories]);

  return (
    <>
      {careerFeedbackQuestionsHistories.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr>
              {TABLE_TITLES?.map((title, index) => (
                <th key={index}>{title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedHistoriesByTermNo.map(history => (
              <tr key={history.id}>
                <td>
                  <div>{history.term_no}回目</div>
                  <div className={styles.date}>
                    {history.realization?.created_at &&
                      format(
                        new Date(history.realization.created_at),
                        "yyyy.M.d",
                      )}
                  </div>
                </td>
                <td>{history.title}</td>
                <td>{history.realization?.content ?? "回答がありません"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className={styles.message}>回答データがありません。</p>
      )}
    </>
  );
};

export default CareerQuestionTable;
